import { ETHOS } from "../../data/content";
import { Reveal, LineRevealOnView } from "../motion/Reveal";

export const Ethos = () => (
  <section
    id="ethos"
    data-testid="ethos-section"
    className="mx-auto max-w-[1500px] px-6 md:px-12 py-16 sm:py-28 md:py-56"
  >
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-8 sm:gap-y-14 lg:gap-x-24 items-center">
      <div className="lg:col-span-7 order-2 lg:order-1">
        <Reveal>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-[var(--hem-needle)]">
            Ethos
          </span>
        </Reveal>
        <h2 className="mt-5 sm:mt-10 font-serif-display font-light leading-[1.15] sm:leading-[1.1] tracking-tight text-[1.6rem] sm:text-3xl md:text-[2.75rem] max-w-2xl">
          <LineRevealOnView text="We are a private" />
          <LineRevealOnView text="holding company." delay={0.08} />
          <LineRevealOnView text="We build, back and hold" delay={0.16} />
          <LineRevealOnView text="companies in healthcare & beyond." delay={0.24} className="italic text-[var(--hem-needle)]" />
        </h2>

        <div className="mt-8 sm:mt-16 max-w-lg">
          {ETHOS.lines.map((line, i) => (
            <Reveal
              key={i}
              delay={i * 0.06}
              className="flex items-baseline gap-4 sm:gap-5 border-t border-[var(--hem-border)] py-4 sm:py-6"
            >
              <span className="font-mono-tech text-[11px] text-[var(--hem-needle)] shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-mono-tech text-[13px] sm:text-sm text-[var(--hem-muted)] leading-relaxed">
                {line}
              </span>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-5 order-1 lg:order-2">
        <Reveal delay={0.15} className="overflow-hidden border border-[var(--hem-border)]">
          <img
            src={ETHOS.image}
            alt="Hemlock foliage"
            className="w-full h-[280px] sm:h-[420px] md:h-[560px] object-cover grayscale-[0.15] hover:grayscale-0 hover:scale-105 transition-[filter,transform] duration-[1000ms] ease-out"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
